"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPageDispose = void 0;
const global_context_1 = __importDefault(require("@ocp/global-context"));
const onPageDispose = (callback) => {
    if (global_context_1.default.isLR) {
        Liferay.once('beforeScreenFlip', () => {
            callback();
        });
    }
};
exports.onPageDispose = onPageDispose;
//# sourceMappingURL=liferay-events.js.map